import { render, staticRenderFns } from "./ModulesModalitiesAndSchedulesSelector.vue?vue&type=template&id=b938f5b4&scoped=true"
import script from "./ModulesModalitiesAndSchedulesSelector.vue?vue&type=script&lang=js"
export * from "./ModulesModalitiesAndSchedulesSelector.vue?vue&type=script&lang=js"
import style0 from "./ModulesModalitiesAndSchedulesSelector.vue?vue&type=style&index=0&id=b938f5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b938f5b4",
  null
  
)

export default component.exports